import React, { ReactNode, Ref } from 'react';

type BaseProps = {
  children: ReactNode;
  className?: string;
  buttonRef?: Ref<HTMLButtonElement | HTMLAnchorElement>;
};

type ButtonAsButton = BaseProps &
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, keyof BaseProps> & {
    as: 'button';
  };

type ButtonAsExternal = BaseProps &
  Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, keyof BaseProps> & {
    as: 'externalLink';
  };

export type ButtonAsLink = Omit<ButtonAsExternal, 'as'> & {
  as: 'link';
};

export type ButtonProps = ButtonAsButton | ButtonAsExternal | ButtonAsLink;

const Button = (props: ButtonProps) => {
  const { as, buttonRef, ...restProps } = props;
  switch (as) {
    case 'link':
      return (
        <a ref={buttonRef as Ref<HTMLAnchorElement>} {...(restProps as Omit<ButtonAsLink, 'as'>)} />
      );
    case 'externalLink':
      return (
        <a
          ref={buttonRef as Ref<HTMLAnchorElement>}
          target="_blank"
          rel="noreferrer"
          {...(restProps as Omit<ButtonAsExternal, 'as'>)}
        />
      );
    case 'button':
      return (
        <button
          ref={buttonRef as Ref<HTMLButtonElement>}
          {...(restProps as Omit<ButtonAsButton, 'as'>)}
        />
      );
    default:
      throw new Error('could not determine the correct button type');
  }
};

export default Button;
